import { DiContainer, Injectable } from '@jack-henry/frontend-utils/di';
import DeviceDetector from 'device-detector-js';

@Injectable()
export class DeviceService {
    constructor() {
        this.deviceInfo = this.getDeviceInfo();
    }

    public static async getInstance() {
        const container = await DiContainer.getInstance();
        return container.get(DeviceService);
    }

    private deviceInfo: DeviceDetector.DeviceDetectorResult;

    private getDeviceInfo() {
        const deviceDetector = new DeviceDetector();
        const { userAgent } = navigator;
        return deviceDetector.parse(userAgent);
    }

    public get osName() {
        const osName = this.deviceInfo?.os?.name;
        return osName === undefined || osName === '' ? 'Unknown' : osName;
    }

    public get osVersion() {
        const osVersion = this.deviceInfo?.os?.version;
        return osVersion === undefined || osVersion === '' ? 'Unknown' : osVersion;
    }

    public get deviceModel() {
        const model = this.deviceInfo?.device?.model;
        return model === undefined || model === '' ? 'Unknown' : model;
    }

    public get isDesktop() {
        const isDesktop = this.deviceInfo?.device?.type === 'desktop';
        return isDesktop === undefined ? false : isDesktop;
    }

    public get isIos() {
        return this.osName === 'iOS';
    }

    public get isSafari() {
        const browserName = this.deviceInfo?.client?.name;
        return browserName?.includes('Safari') === true;
    }
}
